import {createSlice, type SliceSelectors, type SliceCaseReducers} from '@reduxjs/toolkit'

import {getMerchantMerchantPenaltyStatus} from '@web/actions/fdsInfo'
import {MakeCreateSliceOptions, ProductDetailState, getInitialState} from '@web/slices/productDetail/slice'

const ProductDetailSlice = (options?: MakeCreateSliceOptions) =>
    createSlice<
        ProductDetailState,
        SliceCaseReducers<ProductDetailState>,
        'productDetail',
        SliceSelectors<ProductDetailState>
    >({
        name: 'productDetail',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(getMerchantMerchantPenaltyStatus.fulfilled, (state, {payload}) => {
                Object.entries(state.productBundle).forEach(([bundleKey, bundle]) => {
                    const {merchantNo} = bundle
                    if (payload[merchantNo] && state.productBundle[bundleKey]) {
                        state.productBundle[bundleKey].merchantPenaltyStatus = payload[merchantNo].inspectionCode
                        state.productBundle[bundleKey].merchantAbusingCode = payload[merchantNo].abuseCode
                    }
                })
            })

            options?.extraReducers?.(builder)
        },
    })

export default ProductDetailSlice
